import { AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

const CSRFTokenName = 'X-CSRF-Token';
const absoluteUrlRegex = /^(?:[a-z]+:)?\/\//i;

const isRelativeUrl = ({ url }: AxiosRequestConfig): boolean => {
    return url !== undefined && !absoluteUrlRegex.test(url);
};

export const setCSRFTokenHeader = (config: AxiosRequestConfig): AxiosRequestConfig => {
    if (isRelativeUrl(config)) {
        config.headers ??= {};
        const token = Cookies.get(CSRFTokenName);
        if (token) {
            config.headers[CSRFTokenName] ??= token;
        }
    }
    return config;
};
